<template>
    <modal :saveAction="save" :title="title" :id="id" :actionButtons="true" size="full" @shown="shown" @hidden="hidden">
        <div class="labmodal-container">
            <div class="row align-items-top">
                <div class="col-12">
                    <div class="row" v-if="stage === 0">
                        <div class="col-12 col-md-6 mb-4 mb-md-0">
                            <label class="form-label">{{ $t('Patient') }}</label>
                            <div class="card" v-if="customer">
                                <div class="card-body p-2">
                                    <div class="row align-items-center">
                                        <div class="col-auto text-center">
                                            <avatar type="circle" size="avatar-sm"
                                                    :src="customer.avatar.preview"></avatar>
                                        </div>
                                        <div class="col ml-n3">
                                            <h4 class="card-title mb-1">{{customer.first_name}} {{customer.last_name}}</h4>
                                            <p class="card-text small text-muted">
                                                {{customer.phone}}
                                                {{customer.email}}
                                            </p>
                                        </div>
                                        <div class="col-auto">
                                            <button class="btn btn-white btn-sm" @click="data.customerId=null">
                                                <i class="fe fe-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <find-customer v-else v-model="data.customerId"></find-customer>
                        </div>
                        <div class="col-12 col-md-6">
                            <label class="form-label">{{ $t('Technican') }}</label>
                            <find-technician v-model="data.technicianId"></find-technician>
                        </div>
                        <div class="col-12 mt-1" style="border-top: 1px solid #e3ebf6; border-bottom: 1px solid #e3ebf6; padding-bottom: 25px; margin-bottom: 25px;">
                            <teeth-map
                                :value="selectedTeeth"
                                @input="selectTooth"
                                :show-connections="false"
                                :showLabels="true"
                                :selectable="data._id ? false : true"
                                :width="teethMapWidth"
                                :tooths="data.teeth"
                            ></teeth-map>
                            <div class="col-12 mt-3 mb-n3" v-if="data._id ? false : true">
                                <div class="row">
                                    <div class="col d-flex align-items-center">
                                        <div class="custom-control custom-switch" v-if="false">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch1">
                                            <label class="custom-control-label"
                                                   for="customSwitch1">{{$t('Group')}}</label>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <button v-if="selectedTeeth.length"
                                                class="btn btn-outline-secondary"
                                                @click="selectedTeeth = []">
                                            <span class="fe fe-x"></span>
                                            {{$t("Clear selection")}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- stage 0 -->
                    <div class="row" v-if="stage === 1">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <ul class="nav nav-tabs mb-5">
                                        <li class="nav-item">
                                            <a
                                                href="#"
                                                class="nav-link"
                                                :class="{active:tab == 'Main'}"
                                                @click.prevent="tab='Main'"
                                            >{{$t('Main')}}</a>
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                href="#"
                                                class="nav-link"
                                                :class="{active:tab =='Additional'}"
                                                @click.prevent="tab='Additional'"
                                            >{{$t('Additional')}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <template v-if="tab === 'Main'">
                                <main-block v-model="toothOptions"
                                            :data="data"
                                            :teeth-colors.sync="teethColors"
                                            :selected-teeth="selectedTeeth">
                                </main-block>
                            </template>

                            <template v-if="tab === 'Additional'">
                                <advanced-block v-model="toothOptions" :data="data"></advanced-block>
                            </template>
                        </div>
                    </div><!-- stage 1 -->
                    <div class="row" v-else-if="stage === 2">
                        <info-block v-model="data"></info-block>
                    </div><!-- stage 2 -->
                </div>
            </div>
        </div>

        <template slot="modal-footer">
            <div class="card-footer" style="display: block">
                <div class="row">
                    <div class="col">
                        <button v-if="stage !== 0" class="btn btn-outline-secondary" @click="stage--">
                            {{$t("Back")}}
                        </button>
                    </div>
                    <div class="col-auto">
                        <b-button
                            v-if="stage === 1"
                            ref="button"
                            :disabled="loading"
                            @click="save"
                            variant="primary"
                        >{{$t('Save')}}
                        </b-button>

                        <button :disabled="nextDisabled" v-if="stage === 0" class="btn btn-outline-secondary ml-2" @click="stage++">
                            {{$t("Next")}}
                        </button>

                        <button
                            v-if="stage === 2"
                            class="btn btn-white mr-2"
                            v-b-tooltip
                            :title="$t('Print')"
                            @click="openPrintModal(data)"
                        >
                            <i class="fe fe-printer"></i>
                        </button>

                        <button v-if="stage === 2" class="btn btn-outline-secondary ml-2" @click="hide">
                            {{$t("Close")}}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import Modal from "@/components/Modal.vue";
import Avatar from '@/components/Avatar.vue'
import TeethMap from '@/components/Teeth/Map.vue';
import MainBlock from "@/Pages/Company/Labs/MainBlock";
import InfoBlock from "@/Pages/Company/Labs/InfoBlock";
import DatePicker from "@/components/DatePicker";
import FindCustomer from "@/components/FindCustomer";
import AdvancedBlock from "@/Pages/Company/Labs/AdvancedBlock";
import FindTechnician from "@/Pages/Company/Labs/FindTechnician";

export default {
    name: 'LabModal',
    props: ['id'],
    mixins: [modalMixins],
    components: {
        Modal,
        Avatar,
        TeethMap,
        InfoBlock,
        MainBlock,
        DatePicker,
        FindCustomer,
        AdvancedBlock,
        FindTechnician,
    },
    data() {
        return {
            tab: 'Main',
            selectedTeeth: [],
            animation: null,
            stage: 0,
            data: { teeth: [] },
            saveDisabled: false,
            teethMapWidth: 35,
            toothOptions: {},
            teethColors: {},
            dissectOptions: [
                { value: 1, text: '1 ' + this.$t('mm') },
                { value: 2, text: '2 ' + this.$t('mm') }],
            loading: false,
        }
    },

    computed: {
        ...mapGetters('customers', { getCustomer: 'get' }),
        ...mapGetters('my-company', { getMyCompany: 'get' }),

        title() {
            if (this.stage === 1 || this.stage === 2) return `${ this.customer.first_name } ${ this.customer.last_name }`
        },

        nextDisabled() {
            return !this.data.customerId || !this.data.technicianId;
        },

        customer() {
            return this.getCustomer(this.data.customerId);
        },

        company() {
            return this.getMyCompany('mine');
        },
    },

    created() {},

    watch: {
        stage(newVal) {
            if (newVal === 0 && this.data.teeth.length > 0)
                this.data.teeth.forEach(group => this.selectedTeeth = group.teeth)
            if (newVal === 1)
                this.tab = 'Main'
        }
    },

    methods: {
        ...mapActions('labs', ['create', 'patch', 'remove']),
        ...mapActions('customers', {fetchCustomer: 'get'}),

        isConnection(toothNumber) {
            return toothNumber.toString().length === 4
        },

        selectTooth(value) {
            const tooth = value[0] // 17
            if (!this.data._id) {
                this.selectedTeeth = value
                return
            }
            for (const group of this.data.teeth) {
                if (group.teeth.includes(tooth)) {
                    this.selectedTeeth = group.teeth
                    break
                }
            }
        },

        save() {
            this.loading = true

            let group = {}

            Object.keys(this.toothOptions).forEach(key => {
                if (this.toothOptions[key] != null)
                    this.$set(group, key, this.toothOptions[key] || null)
            });

            this.$set(group, 'treatmentId', (this.toothOptions.treatment || {})._id)

            this.$set(group, 'teeth', this.selectedTeeth || null)

            this.$set(group, 'teethColors', {})
            for(const [key, val] of Object.entries(this.teethColors)) {
                for(const [k, v] of Object.entries(val)) {
                    if (v!==null) {
                        if (!group.teethColors[key]) this.$set(group.teethColors, key, {})
                        this.$set(group.teethColors[key], k, v)
                    }
                }
            }

            this.data.teeth = [group]

            if (this.data.forSending) {
                let arr = this.data.forSending.filter(a => a.qty != false);
                this.$set(this.data, 'forSending', arr);
            }
            if (this.data.images) {
                this.$set(this.data, 'images', (this.data.images.map(a => ({imageId:a.image._id}))));
            }
            if (this.data.faceShape == null) {
                delete this.data.faceShape
            }

            if (this.data._id) {
                this.patch([this.data._id, this.data]).then(res => {
                    this.data.images = res.images
                    this.loading = false
                    this.stage++
                });
            } else {
                this.create(this.data).then(res => {
                    this.data._id = res._id
                    if (res.images.length > 0)
                        this.$set(this.data, 'images', res.images)
                    this.$set(this.data, 'createdAt', res.createdAt)
                    this.$set(this.data, 'labNumber', res.labNumber)
                    this.loading = false
                    this.stage++
                })
            }
        },

        shown() {
            const { Lab } = this.$FeathersVuex;
            let data = Lab.getFromStore('temp');

            if (data) {
                delete data._id;
                this.data = this.$copy(data.model);

                if (this.data._id){
                    this.data.teeth.forEach(option => {
                        if (option.teeth && option.teeth !== null && option.teeth.length > 0) this.selectedTeeth = option.teeth
                        if (option.teethColors) this.teethColors = option.teethColors
                        this.toothOptions = option
                    })

                    this.fetchCustomer(this.data.customerId)
                }

                new Lab({
                    model: {},
                    _id: 'temp'
                });
            }

            if (!this.data.teeth)
                this.$set(this.data, 'teeth', []);

            if (!this.data.fittings)
                this.$set(this.data, 'fittings', []);

            if (!this.data.images)
                this.$set(this.data, 'images', []);

            if (!this.data.forSending)
                this.$set(this.data, 'forSending', [
                    { text: this.$t('Spoons'), qty: '' },
                    { text: this.$t('Screws'), qty: '' },
                    { text: this.$t('Abutments'), qty: '' },
                    { text: this.$t('Implants'), qty: '' },
                    { text: this.$t('Transfers'), qty: '' },
                    { text: this.$t('Analogues'), qty: '' }
                ]);
        },

        hidden() {
            this.stage = 0;
            this.data = { teeth: [] };
            this.selectedTeeth = [];
            this.toothOptions = { treatment: {} };
            this.teethColors = {};
        },

        hide() {
            this.$root.$emit('bv::hide::modal', this.id)
        },

        openPrintModal(lab) {
            this.openModal({ id: 'PrintLabModal' });
            const { Lab } = this.$FeathersVuex;
            new Lab({
                model: lab,
                _id: 'temp'
            });
        },
    },
}
</script>

<style lang="scss">

.labmodal-container {
    position: relative;
    height: 78vh;
    width: 100%;
    overflow: auto;
    overflow-x: hidden;
}

.labs-table {
    &-heading {
        text-align: center;
        background: #f9fbfd;
        color: #95aac9;
        font-weight: 900;
    }
}

.append-image {
    display: flex;
    flex-wrap: wrap;
}

</style>
